import { detailsBig, h2, paragraph } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 36px;
  width: 100%;
  margin-bottom: 34px;

  @media screen and (max-width: 992px) {
    margin-bottom: 18px;
  }

  @media screen and (max-width: 820px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const Image = styled(GatsbyImage)``;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled(h2)`
  margin-bottom: 10px;
`;

const Text = styled(detailsBig)``;

const S = {
  Container,
  ImageWrapper,
  Image,
  TextWrapper,
  Title,
  Text,
};

export default S;
